import { createMuiTheme } from '@material-ui/core/styles';


const backgroundColor =  '#292929';
const textColor = 'white';
const accentColor = 'rgb(168, 255, 96)';

export { backgroundColor, textColor, accentColor };